import {RsvpStatus} from '@wix/events-types'
import {EventsDates} from '@wix/wix-events-commons-statics'
import {ControllerParams} from '@wix/yoshi-flow-editor'
import {Api as BaseApi} from '../../../../commons/utils/api'
import {getComponentData} from '../../shared-api'

export class Api extends BaseApi {
  constructor(controllerParams: ControllerParams) {
    super(controllerParams)
  }

  getEvents = ({
    memberId,
    statuses,
    extended,
    offset = 0,
    locale,
  }: {
    memberId: string
    statuses: wix.events.EventStatus[]
    extended: boolean
    offset: number
    locale: string
  }): Promise<{
    events: wix.events.Event[]
    orders: wix.events.ticketing.Order[]
    rsvps: wix.events.rsvp.Rsvp[]
    total: number
    dates: {events: EventsDates}
  }> =>
    this.api.get(
      `/web/member-events?memberId=${memberId}&instance=${this.getInstance()}&extended=${extended}&offset=${offset}&locale=${locale}${statuses
        .map(status => `&status=${status}`)
        .join('')}`,
    )

  getComponentData = getComponentData(this.api)

  deleteRsvp = ({eventId, rsvpId}: {eventId: string; rsvpId: string}) =>
    this.api.delete(`/web/events/${eventId}/rsvp/${rsvpId}`).then(() => ({eventId}))

  cancelRsvp = ({eventId, rsvpId}: {eventId: string; rsvpId: string}) =>
    this.api.put(`/web/events/${eventId}/rsvp/${rsvpId}/status`, {status: RsvpStatus.NO}).then(() => ({eventId}))

  getMyTickets = (eventId: string, memberId: string): Promise<{tickets: wix.events.ticketing.Ticket[]}> =>
    this.api.get(`/web/events/${eventId}/my-tickets?memberId=${memberId}`)
}
